<main class="log-in">
   <div class="left-side">
      <img src="../../assets/images/Crossplag_Logo_Negativ.png" alt="" />
      <div>
         <img *ngIf="profile == 'individual'" src="../../../assets/images/individualIconTransparent.png" alt="">
         <img *ngIf="profile == 'business'" src="../../../assets/images/businessLogoTransparent.png" alt="">
         <img *ngIf="profile == 'institution'" src="../../../assets/images/institutionLogoTransparent.png" alt="">
         <h1 *ngIf="!profile">The most advanced & affordable plagiarism checking tool.</h1>
         <h1 *ngIf="profile == 'individual'">Individual Profile</h1>
         <h1 *ngIf="profile == 'institution'">Institution Profile</h1>
         <h1 *ngIf="profile == 'business'">Business Profile</h1>
         <p *ngIf="!profile" [innerHtml]="'login.crossplag_description' | translate"> 
         </p>
         <p *ngIf="profile == 'individual'"> Our plagiarism detection tool helps students, teachers, writers, and bloggers ensure originality in their work by comparing each writing with more than 100 billion texts worldwide.
         </p>
         <a class="readMore" *ngIf="profile == 'individual'" #readMoreIndividual href="https://crossplag.com/crossplag-for-individuals/" target="_blank">Read more</a>
         <p *ngIf="profile == 'institution'">Our self-provisioning plagiarism detection tool is affordable, customizable, and powerful while enabling institutions to have full ownership and control over their data. 
         </p>
         <a class="readMore" *ngIf="profile == 'institution'" #readMoreInstitution [href]="readMoreClicked?'#':'https://crossplag.com/crossplag-for-education/'" target="_blank">Read more</a>
         <p *ngIf="profile == 'business'">Our Similarity Report API enables your business to ensure originality and easily integrate with your current workflows. We offer white-labeling solutions to education and publishing businesses.
         </p>
         <a class="readMore" *ngIf="profile == 'business'" #readMoreBusiness href="https://crossplag.com/crossplag-for-education/" target="_blank">Read more</a>
      </div>
      <h6>© All rights reserved - Crossplag™</h6>
      <svg
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 1037.98 1031.18"
         width="1037.98"
         height="1031.18"
      >
         <defs>
            <style>
               .a {
                  fill: #fff;
                  opacity: 0.1;
               }
            </style>
         </defs>
         <path
            class="a"
            transform="translate(-93 -95.546)"
            d="M 1051.52 401.347 q -75.5 -75.5 -149.927 -77.66 c -1.079 -22.291 -7.191 -44.942 -17.977 -68.312 c -12.224 -26.606 -31.28 -52.852 -57.526 -79.1 c -48.9 -48.9 -100.311 -75.5 -153.522 -80.177 C 619 91.786 569.386 112.639 523.006 158.66 q -30.2 30.2 -50.695 72.267 q -20.494 42.6 -25.887 103.546 a 596.2 596.2 0 0 0 -1.079 62.919 c 0.36 7.55 0.36 15.1 0.719 23.01 c 0.36 15.46 0.719 32 1.438 48.178 c 1.079 24.448 1.8 49.616 2.517 75.143 s 0.36 50.695 -1.079 75.5 c -2.157 29.482 -6.112 52.852 -12.584 69.39 C 430.964 703 422.335 716.66 410.83 729.244 l -10.067 10.067 q -69.031 64.717 -140.219 -6.112 c -26.246 -26.246 -39.549 -51.773 -40.268 -76.581 c 0 -48.178 29.123 -67.233 29.123 -67.233 c 35.954 -35.954 168.982 -34.156 168.982 -34.156 l -5.753 -80.9 c -0.719 -11.865 -11.505 -16.179 -23.37 -17.258 c 0 0 -141.3 -16.539 -231.182 55.728 c 0 0 -65.076 46.74 -65.076 151.005 c 2.876 54.29 29.122 106.782 79.458 157.117 s 100.311 76.222 149.927 77.66 c 1.079 22.291 7.191 44.942 17.977 68.312 c 12.224 26.606 31.28 52.852 57.526 79.1 c 48.9 48.9 100.311 75.5 153.522 80.177 c 53.571 4.314 103.187 -16.539 149.567 -62.559 q 30.2 -30.2 50.695 -72.267 q 20.494 -42.605 25.887 -103.546 a 596.153 596.153 0 0 0 1.079 -62.919 c -0.719 -22.651 -1.438 -46.38 -2.517 -70.829 v -2.517 c -1.078 -23.729 -1.438 -47.818 -2.157 -72.626 q -1.079 -38.291 1.079 -75.5 c 2.157 -29.482 6.112 -52.852 12.584 -69.391 c 5.393 -14.381 14.022 -28.044 25.527 -40.628 l 10.067 -10.067 q 69.031 -64.717 140.219 6.112 c 26.246 26.246 39.549 51.773 40.268 76.581 c 0 48.178 -29.122 67.233 -29.122 67.233 C 938.63 669.2 805.6 667.4 805.6 667.4 l 5.753 80.9 c 0.719 11.865 11.865 16.9 23.37 17.258 c 0 0 141.3 16.539 231.182 -55.728 c 0 0 65.076 -46.74 65.076 -151.005 C 1128.46 503.815 1101.86 451.682 1051.52 401.347 Z m -293.741 -23.37 a 284.893 284.893 0 0 0 -21.932 20.134 c -20.853 20.853 -38.471 44.942 -53.931 72.267 Q 659.27 511.9 652.8 569.61 c -1.8 16.539 -2.876 54.65 -2.876 54.65 c 0 4.314 -0.36 8.629 -0.36 12.943 q 0 37.212 2.157 75.5 c 1.438 25.527 2.517 50.335 3.6 75.143 c 1.079 24.448 1.079 46.74 0.359 66.874 c -0.719 32.358 -4.314 56.807 -11.505 73.345 c -6.831 16.539 -15.82 30.2 -26.965 41.347 c -18.7 18.7 -39.189 27.684 -61.481 27.325 s -45.661 -12.584 -69.75 -36.673 c -39.909 -39.909 -46.74 -78.738 -19.774 -116.49 c 6.831 -7.191 13.662 -14.022 20.853 -21.213 c 20.853 -20.853 39.909 -43.5 55.009 -71.188 s 24.808 -60.762 29.122 -99.232 a 633.525 633.525 0 0 0 3.236 -67.233 c 0 -11.865 0 -24.448 -0.359 -36.313 c -0.36 -12.943 -0.719 -26.246 -1.438 -39.189 c -1.438 -25.527 -2.517 -50.335 -3.6 -75.143 c -1.079 -24.448 -1.079 -46.74 -0.36 -66.874 c 0.719 -32.358 4.314 -56.807 11.505 -73.345 c 6.831 -16.539 15.82 -30.2 26.965 -41.347 c 18.7 -18.7 39.189 -27.684 61.481 -27.325 s 45.661 12.584 69.75 36.673 C 778.277 301.755 791.939 340.226 757.783 377.977 Z"
         />
      </svg>
   </div>
   <div class="right-side">
      <!-- <i class="fas fa-arrow-left"></i> -->
     <span *ngIf="profile" routerLink="/login" class="go-back">Already have an account? Sign in</span>
     <div class="dispalyOnDesktop">
      <h2 *ngIf="!profile">Welcome to Crossplag</h2>
     </div>
<div class="displayOnMobile">
   <h2>Welcome to Crossplag</h2>
   <img src="../../../assets/images/Crossplag_Logo (3).png" alt="">
</div>
      <form class="form-container" *ngIf="profile == 'individual'" action="" (ngSubmit)="signUp()" [formGroup]="signupForm">
         <h3>{{ 'login.sign_up' | translate }}</h3>
         <div>
            <label for="">First name</label>
            <input
               class="capitalize"
               placeholder="{{ 'general.first_name' | translate }}"
               formControlName="first_name"
            />
            <div
               *ngIf="form.first_name.invalid && form.first_name.touched"
               class="invalid"
            >
               <div *ngIf="form.first_name.errors.required">
                  {{ 'validators.first_name_required' | translate }}
               </div>
               <div
                  *ngIf="
                     form.first_name.errors.minlength &&
                     !form.first_name.errors.pattern
                  "
               >
                  {{ 'validators.first_name_minLength' | translate }}
               </div>
               <div *ngIf="form.first_name.errors.pattern">
                  {{ 'validators.first_name_only_letters' | translate }}
               </div>
            </div>
         </div>
         <div>
            <label for="">Last name</label>
            <input
               placeholder="Last name"
               formControlName="last_name"
               class="capitalize"
            />
            <div
               *ngIf="form.last_name.invalid && form.last_name.touched"
               class="invalid"
            >
               <div *ngIf="form.last_name.errors.required">
                  {{ 'validators.last_name_required' | translate }}
               </div>
               <div *ngIf="form.last_name.errors.pattern">
                  {{ 'validators.last_name_only_letters' | translate }}
               </div>
               <div
                  *ngIf="
                     form.last_name.errors.minlength &&
                     !form.last_name.errors.pattern
                  "
               >
                  {{ 'validators.last_name_minLength' | translate }}
               </div>
            </div>
         </div>

         <div>
            <label for="">Email</label>
            <input
               placeholder="Email"
               formControlName="email"
            />
            <div
               *ngIf="form.email.invalid && form.email.touched"
               class="invalid"
            >
               <div *ngIf="form.email.errors.required">
                  {{ 'validators.email_required' | translate }}
               </div>
               <div *ngIf="form.email.errors.email">
                  {{ 'validators.valid_email' | translate }}
               </div>
            </div>
            <div class="invalid" *ngIf="invalidEmail">
               Disposable emails are not allowed
            </div>
         </div>
         <div class="terms">
            <input
               name="terms_and_conditions"
               id="terms_and_conditions"
               type="checkbox"
               formControlName="agree"
            />
            <label for="terms_and_conditions"></label>
            <a mat-button (click)="openModal()">
               {{ 'general.terms_and_conditions' | translate }}</a
            >
         </div>
         <div class="terms marketing_emails">
            <input
               name="emails"
               id="emails"
               type="checkbox"
               (click)="acceptMarketing()"
            />
            <label for="emails"></label>
            <a
               >Yes, I would like to receive offers, updates and marketing by
               Email.
            </a>
         </div>
         <re-captcha
         formControlName="recaptcha"
         (resolved)="resolved($event)"
         [siteKey]="siteKey"
       ></re-captcha>
         <ng-container *ngIf="signupForm.valid">
            <button type="submit" class="submit">
               {{ 'general.join_now' | translate }}
            </button>
         </ng-container>
         <ng-container *ngIf="signupForm.invalid">
            <button
               [ngClass]="{ disable: signupForm.invalid }"
               [disabled]="signupForm.invalid"
               type="submit"
               class="submit"
               (click)="showToasterWarning('Please re-check your info')"
            >
               {{ 'general.join_now' | translate }}
            </button>
         </ng-container>
         <div class="social-container">
            <div class="seperator-line">
               <i class="line-seperator"></i>
               <span>{{ 'login.or' | translate }}</span>
               <i class="line-seperator"></i>
            </div>
            <div>
               <span>{{ 'login.sign_in_with' | translate }}</span>
            </div>
            <div>
               <span
                  >By continuing I agree with the
                  <a mat-button (click)="openModal()">
                     Privacy Policy, Terms & Conditions</a
                  ></span
               >
            </div>
            <div class="social-buttons">
               <a
                  class="btn btn-social-icon btn-google"
                  (click)="signInWithGoogle()"
               >
                  <svg
                     viewBox="0 0 533.5 544.3"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M533.5 278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.1-117.4 81.1-200.2z"
                        fill="#4285f4"
                     />
                     <path
                        d="M272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-152.8-112.3H28.9v70.1c46.2 91.9 140.3 149.9 243.2 149.9z"
                        fill="#34a853"
                     />
                     <path
                        d="M119.3 324.3c-11.4-33.8-11.4-70.4 0-104.2V150H28.9c-38.6 76.9-38.6 167.5 0 244.4l90.4-70.1z"
                        fill="#fbbc04"
                     />
                     <path
                        d="M272.1 107.7c38.8-.6 76.3 14 104.4 40.8l77.7-77.7C405 24.6 339.7-.8 272.1 0 169.2 0 75.1 58 28.9 150l90.4 70.1c21.5-64.5 81.8-112.4 152.8-112.4z"
                        fill="#ea4335"
                     />
                  </svg>
                  <span class="social-button-text">{{
                     'login.google' | translate
                  }}</span>
               </a>
   
               <a
                  class="btn btn-social-icon btn-linkedin"
                  (click)="loginLinkedin()"
               >
                  <svg
                     version="1.1"
                     id="Layer_1"
                     xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink"
                     x="0px"
                     y="0px"
                     viewBox="0 0 382 382"
                     style="enable-background: new 0 0 382 382"
                     xml:space="preserve"
                  >
                     <path
                        style="fill: #0077b7"
                        d="M347.445,0H34.555C15.471,0,0,15.471,0,34.555v312.889C0,366.529,15.471,382,34.555,382h312.889
       C366.529,382,382,366.529,382,347.444V34.555C382,15.471,366.529,0,347.445,0z M118.207,329.844c0,5.554-4.502,10.056-10.056,10.056
       H65.345c-5.554,0-10.056-4.502-10.056-10.056V150.403c0-5.554,4.502-10.056,10.056-10.056h42.806
       c5.554,0,10.056,4.502,10.056,10.056V329.844z M86.748,123.432c-22.459,0-40.666-18.207-40.666-40.666S64.289,42.1,86.748,42.1
       s40.666,18.207,40.666,40.666S109.208,123.432,86.748,123.432z M341.91,330.654c0,5.106-4.14,9.246-9.246,9.246H286.73
       c-5.106,0-9.246-4.14-9.246-9.246v-84.168c0-12.556,3.683-55.021-32.813-55.021c-28.309,0-34.051,29.066-35.204,42.11v97.079
       c0,5.106-4.139,9.246-9.246,9.246h-44.426c-5.106,0-9.246-4.14-9.246-9.246V149.593c0-5.106,4.14-9.246,9.246-9.246h44.426
       c5.106,0,9.246,4.14,9.246,9.246v15.655c10.497-15.753,26.097-27.912,59.312-27.912c73.552,0,73.131,68.716,73.131,106.472
       L341.91,330.654L341.91,330.654z"
                     />
                  </svg>
                  <span class="social-button-text">{{
                     'login.linkedin' | translate
                  }}</span>
               </a>
            </div>
         </div>
      </form>
      <form class="form-container" *ngIf="profile == 'institution'" action="" (ngSubmit)="signUp()" [formGroup]="signupForm">
         <h3>{{ 'login.sign_up' | translate }}</h3>
         <div>
            <label for="">First name</label>
            <input
               placeholder="First name"
               class="capitalize"
               formControlName="first_name"
            />
            <div
               *ngIf="form.first_name.invalid && form.first_name.touched"
               class="invalid"
            >
               <div *ngIf="form.first_name.errors.required">
                  {{ 'validators.first_name_required' | translate }}
               </div>
               <div
                  *ngIf="
                     form.first_name.errors.minlength &&
                     !form.first_name.errors.pattern
                  "
               >
                  {{ 'validators.first_name_minLength' | translate }}
               </div>
               <div *ngIf="form.first_name.errors.pattern">
                  {{ 'validators.first_name_only_letters' | translate }}
               </div>
            </div>
         </div>
         <div>
            <label for="">Last name</label>
            <input
               placeholder="Last name"
               formControlName="last_name"
               class="capitalize"
            />
            <div
               *ngIf="form.last_name.invalid && form.last_name.touched"
               class="invalid"
            >
               <div *ngIf="form.last_name.errors.required">
                  {{ 'validators.last_name_required' | translate }}
               </div>
               <div *ngIf="form.last_name.errors.pattern">
                  {{ 'validators.last_name_only_letters' | translate }}
               </div>
               <div
                  *ngIf="
                     form.last_name.errors.minlength &&
                     !form.last_name.errors.pattern
                  "
               >
                  {{ 'validators.last_name_minLength' | translate }}
               </div>
            </div>
         </div>
         <div>
            <label for="">Email</label>
            <input
               placeholder="Email"
               formControlName="email"
            />
            <div
               *ngIf="form.email.invalid && form.email.touched"
               class="invalid"
            >
               <div *ngIf="form.email.errors.required">
                  {{ 'validators.email_required' | translate }}
               </div>
               <div *ngIf="form.email.errors.email">
                  {{ 'validators.valid_email' | translate }}
               </div>
            </div>
            <div class="invalid" *ngIf="invalidEmail">
               Disposable emails are not allowed
            </div>
         </div>
         <div>
            <label for="">Institution name</label>
            <input
               placeholder="Institution name"
               formControlName="institution"
            />
            <div
               *ngIf="form.institution.invalid && form.institution.touched"
               class="invalid"
            >
               <div *ngIf="form.institution.errors.required">
                  Institution name is required
               </div>

               <div *ngIf="form.institution.errors.minlength">
                  Institution name should have more than 3 characters
               </div>
            </div>
         </div>
         <div>
            <label for="">Role</label>
            <input
               placeholder="e.g IT, Administrator, Professor, etc."
               formControlName="role"
            />
            <div
               *ngIf="form.role.invalid && form.role.touched"
               class="invalid"
            >
               <div *ngIf="form.institution.errors.required">
                  Role is required
               </div>
            </div>
         </div>
         <div>
            <label for="">Country</label>
            <input
               placeholder="Where is your institution situated?"
               formControlName="country"
            />
            <div
               *ngIf="form.country.invalid && form.country.touched"
               class="invalid"
            >
               <div *ngIf="form.country.errors.required">
                  Country is required
               </div>
            </div>
         </div>
         <div>
            <label for="">Does your institution currently use a system to prevent plagiarism?*
            </label>
            <input
               placeholder=""
               formControlName="currentSystem"
            />
         </div>
         <div class="terms">
            <input
               name="terms_and_conditions"
               id="terms_and_conditions"
               type="checkbox"
               formControlName="agree"
            />
            <label for="terms_and_conditions"></label>
            <a mat-button (click)="openModal()">
               {{ 'general.terms_and_conditions' | translate }}</a
            >
         </div>
         <div class="terms marketing_emails">
            <input
               name="emails"
               id="emails"
               type="checkbox"
               (click)="acceptMarketing()"
            />
            <label for="emails"></label>
            <a
               >Yes, I would like to receive offers, updates and marketing by
               Email.
            </a>
         </div>
         <re-captcha
         formControlName="recaptcha"
            (resolved)="resolved($event)"
            [siteKey]="siteKey"
          ></re-captcha>
            <ng-container *ngIf="signupForm.valid">
            <button type="submit" class="submit">
               {{ 'general.join_now' | translate }}
            </button>
         </ng-container>
         <ng-container *ngIf="signupForm.invalid">
            <button
               [ngClass]="{ disable: signupForm.invalid }"
               [disabled]="signupForm.invalid"
               type="submit"
               class="submit"
               (click)="showToasterWarning('Please re-check your info')"
            >
               {{ 'general.join_now' | translate }}
            </button>
         </ng-container>
      </form>
      <form  class="form-container" *ngIf="profile == 'business'" action="" (ngSubmit)="signUp()" [formGroup]="signupForm">
         <h3>Contact us</h3>
         <div>
            <label for="">First name</label>
            <input
               class="capitalize"
               placeholder="First name"
               formControlName="first_name"
            />
            <div
               *ngIf="form.first_name.invalid && form.first_name.touched"
               class="invalid"
            >
               <div *ngIf="form.first_name.errors.required">
                  {{ 'validators.first_name_required' | translate }}
               </div>
               <div
                  *ngIf="
                     form.first_name.errors.minlength &&
                     !form.first_name.errors.pattern
                  "
               >
                  {{ 'validators.first_name_minLength' | translate }}
               </div>
               <div *ngIf="form.first_name.errors.pattern">
                  {{ 'validators.first_name_only_letters' | translate }}
               </div>
            </div>
         </div>
         <div>
            <label for="">Last name</label>
            <input
               placeholder="Last name"
               formControlName="last_name"
               class="capitalize"
            />
            <div
               *ngIf="form.last_name.invalid && form.last_name.touched"
               class="invalid"
            >
               <div *ngIf="form.last_name.errors.required">
                  {{ 'validators.last_name_required' | translate }}
               </div>
               <div *ngIf="form.last_name.errors.pattern">
                  {{ 'validators.last_name_only_letters' | translate }}
               </div>
               <div
                  *ngIf="
                     form.last_name.errors.minlength &&
                     !form.last_name.errors.pattern
                  "
               >
                  {{ 'validators.last_name_minLength' | translate }}
               </div>
            </div>
         </div>

         <div>
            <label for="">Email</label>
            <input
               placeholder="Email"
               formControlName="email"
            />
            <div
               *ngIf="form.email.invalid && form.email.touched"
               class="invalid"
            >
               <div *ngIf="form.email.errors.required">
                  {{ 'validators.email_required' | translate }}
               </div>
               <div *ngIf="form.email.errors.email">
                  {{ 'validators.valid_email' | translate }}
               </div>
            </div>
            <div class="invalid" *ngIf="invalidEmail">
               Disposable emails are not allowed
            </div>
         </div>
         <div>
            <label for="">Role</label>
            <input
               placeholder="Role"
               formControlName="role"
            />
            <div
               *ngIf="form.role.invalid && form.role.touched"
               class="invalid"
            >
               <div *ngIf="form.role.errors.required">
                  Role is required
               </div>
            </div>
         </div>

         <div>
            <label for="">Company</label>
            <input
               placeholder="Company"
               formControlName="company"
            />
            <div
               *ngIf="form.company.invalid && form.company.touched"
               class="invalid"
            >
               <div *ngIf="form.company.errors.required">
                  Company is required
               </div>
            </div>
         </div>

         <div>
            <label for="">Country</label>
            <input
               placeholder="Country"
               formControlName="country"
            />
            <div
               *ngIf="form.country.invalid && form.country.touched"
               class="invalid"
            >
               <div *ngIf="form.country.errors.required">
                  Country is required
               </div>
            </div>
         </div>

         
         <div>
            <label for="">Message</label>
            <textarea   placeholder="Message"
            formControlName="message" name="" id="" cols="30" rows="4"></textarea>
            <div
               *ngIf="form.message.invalid && form.message.touched"
               class="invalid"
            >
               <div *ngIf="form.message.errors.required">
                  Message is required
               </div>
            </div>
         </div>

         <div class="terms">
            <input
               name="terms_and_conditions"
               id="terms_and_conditions"
               type="checkbox"
               formControlName="agree"
            />
            <label for="terms_and_conditions"></label>
            <a mat-button (click)="openModal()">
               {{ 'general.terms_and_conditions' | translate }}</a
            >
         </div>
         <div class="terms marketing_emails">
            <input
               name="emails"
               id="emails"
               type="checkbox"
               (click)="acceptMarketing()"
            />
            <label for="emails"></label>
            <a
               >Yes, I would like to receive offers, updates and marketing by
               Email.
            </a>
         </div>
         <re-captcha
         (resolved)="resolved($event)"
         [siteKey]="siteKey"
         formControlName="recaptcha"
       ></re-captcha>
         
         <ng-container *ngIf="signupForm.valid">
            <button type="submit" class="submit">
               Sent
            </button>
         </ng-container>
         <ng-container *ngIf="signupForm.invalid">
            <button
               [ngClass]="{ disable: signupForm.invalid }"
               [disabled]="signupForm.invalid"
               type="submit"
               class="submit"
               (click)="showToasterWarning('Please re-check your info')"
            >
               Sent
            </button>
         </ng-container>
      </form>
      <div *ngIf="!profile" class="right-side profileSelection">
         <p>Choose your profile that you want to sign up</p>
         <div (click)="changeRoute('individual')"> 
          <img src="../../../assets/images/individualLogoLogin.png" alt="">
          <div>
             <div>
               <h4>Individual</h4>

             </div>
             <i class="fas fa-chevron-right"></i>
          </div>
         </div>
         <div (click)="changeRoute('institution')">
          <img src="../../../assets/images/institutionLogoLogin.png" alt="">
          <div>
            <div>
               <h4>Institution</h4>
            </div>
             <i class="fas fa-chevron-right"></i>
          </div>
         </div>
         <div (click)="changeRoute('business')">
          <img src="../../../assets/images/businessLogoLogin.png" alt="">
          <div>
            <div>
               <h4>Business</h4>
            </div>
             <i class="fas fa-chevron-right"></i>
          </div>
         </div>
         <hr>
         <span>Already have an account?</span>
         <a routerLink="/login">Sign In</a>
       </div>
   </div>
</main>
